import React from 'react';

function Footer() {

    return (
            <div id="footer" className="py-4 mt-4 bg-purple">
                <div className="container text-center">
                    <p>UW Creative Communications / 3900 Seventh Ave N.E. / Box 359000 / Seattle, Washington 98195 / 206.543.5680 / 206.685.3411 fax</p>
                    <p><a href="https://finance.uw.edu/c2/">Back to Creative Communications</a> | <a href="mailto:barcode@uw.edu">Postage Account Contact</a></p>
                    <p>UW Creative Communications is a division of <a href="https://finance.uw.edu/">Finance & Administration</a></p>
                </div>
            </div>        
    );
}

export default Footer;
